import { type TiptapDocContent } from '../../model'
import { tiptapToMarkdown } from '../tiptapToMarkdown'

export const GAME_LADDER_TERM: TiptapDocContent = {
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      content: [
        {
          type: 'text',
          text: 'By participating in this competition participants agree to abide by the following Terms and Conditions:',
        },
      ],
    },
    {
      type: 'heading',
      attrs: { level: 4 },
      content: [{ type: 'text', text: 'Scoring' }],
    },
    {
      type: 'paragraph',
      content: [
        {
          type: 'text',
          text: 'Points are awarded for one or more activities/outcomes selected by the competition organizer. If Day Boost is added to a scoring metric, the organizer will decide the days on which points will be boosted and by how much (2x, 3x, 5x, etc.). Booster days will be visible to all in the scoring section of the competition summary and will also be announced on the competition leaderboard page on days when points are boosted. If a qualifier (secondary action/outcome) is added to the pitch scoring metric, that qualifier must be met in order to be awarded the assigned points for pitches. The competition organizer reserves the right to make final decisions on scoring-related disputes.',
        },
      ],
    },
    {
      type: 'heading',
      attrs: { level: 4 },
      content: [{ type: 'text', text: 'Tie Breakers' }],
    },
    {
      type: 'paragraph',
      content: [
        {
          type: 'text',
          text: 'In the event of tied scores at the end of a round or competition, the tie breaker metric selected during set up will determine the ranking and/or winner. If no tie breakers were selected during competition set up, the organizer reserves the right to apply other tiebreakers or otherwise determine the final outcome of a tied competition.',
        },
      ],
    },
    {
      type: 'heading',
      attrs: { level: 4 },
      content: [{ type: 'text', text: 'Fair Play' }],
    },
    {
      type: 'paragraph',
      content: [
        {
          type: 'text',
          text: 'Cheating, unethical activities, or unsportsmanlike behavior will result in immediate disqualification. This includes using scoring metrics which you personally did not generate, using illegitimate accounts or actions, manipulating scores, or any other form of dishonest play. The competition organizer reserves the right to investigate fair play violations and take action at their discretion.',
        },
      ],
    },
    {
      type: 'heading',
      attrs: { level: 4 },
      content: [{ type: 'text', text: 'Competition Timeline, Scoring, and Prizes' }],
    },
    {
      type: 'paragraph',
      content: [
        {
          type: 'text',
          text: 'See the competition Details section for more information on competition start and end dates as well as scoring metrics. Information regarding competition prizes can be found in the Prizes section. The competition organizer reserves the right to adjust competition timeline and prizes at any time at their discretion.',
        },
      ],
    },
  ],
}

export const GAME_LADDER_TERM_MARKDOWN: string = tiptapToMarkdown(GAME_LADDER_TERM)
